















































































import Vue from 'vue';
import _ from 'lodash';
import moment from 'moment-timezone';

import Requester from '../../requester';
import { filterDeburr } from '../../utils/functions';
import { statusExameItems, tipoPartoStrings } from '../../utils/constants';

import { Gestacao } from '../../../../back/src/entity/Gestacao';
import { Paciente } from '../../../../back/src/entity/Paciente';
import { Vacina } from '../../../../back/src/entity/Vacina';
import { Vacinacao } from '../../../../back/src/entity/Vacinacao';
import { VacinacoesFormData, TipoParto } from '../../../../back/src/types';

export default Vue.extend({
  name: 'VacinacoesForm',
  props: {
    paciente: {
      type: Object as () => Paciente,
    },
    gestacao: {
      type: Object as () => Gestacao,
    },
    vacinacao: {
      type: Object as () => Vacinacao,
    },
  },
  data() {
    return {
      loading: {
        submit: false,
      },
      menuDataVacinacao: false,
      valid: false,
      searchInput: '',
      form: {
        vacinaId: this.vacinacao.vacina_id,
        nomeVacina: this.vacinacao.nome_vacina,
        dataVacinacao: moment(this.vacinacao.data_vacinacao).isValid()
          ? moment(this.vacinacao.data_vacinacao).format('YYYY-MM-DD')
          : '',
      },
      rules: {
        required: [
          (v: string) => !!v || 'Campo obrigatório',
        ],
      },
    };
  },
  computed: {
    vRowClass(): string {
      if (this.$vuetify.breakpoint.xsOnly) {
        return 'd-flex flex-column';
      }
      return '';
    },
    vColClass(): string {
      return 'pt-1 pb-2';
    },
    formVacinacoes():
      Vue & { validate: () => boolean, reset: () => void, resetValidation: () => void } {
      return this.$refs.formVacinacoes as Vue & {
        validate: () => boolean,
        reset: () => void,
        resetValidation: () => void
      };
    },
    dataVacinacaoFormatada(): string {
      if (this.form.dataVacinacao) {
        const momentData = moment(this.form.dataVacinacao);
        if (momentData.isValid()) {
          return momentData.format('DD/MM/YYYY');
        }
      }
      return '';
    },
  },
  methods: {
    filterDeburr(item: any, queryText: string, itemText: string) {
      return filterDeburr(queryText, itemText);
    },
    // eslint-disable-next-line func-names
    submitFormDebounce: _.debounce(async function () { await this.submitForm(); }, 200),
    async submitForm() {
      if (!this.formVacinacoes.validate()) {
        return;
      }
      const formData: VacinacoesFormData = {
        id: this.vacinacao.id,
        paciente_id: this.vacinacao.paciente_id,
        gestacao_id: this.vacinacao.gestacao_id,
        vacina_id: this.vacinacao.vacina_id,
        nome_vacina: this.form.nomeVacina,
        data_vacinacao: moment(this.form.dataVacinacao).isValid()
          ? moment(this.form.dataVacinacao).toDate()
          : null,
      };
      this.loading.submit = true;
      try {
        const response = await Requester.vacinacao.atualizaVacinacao(formData);
        if (response.errors.length > 0) {
          this.$root.$emit('avisoSnackbar', { color: 'error', text: response.errors });
        } else {
          this.$root.$emit('avisoSnackbar', { color: 'success', text: 'Dados salvos com sucesso' });
          this.$emit('atualizaVacinacao', response.data);
        }
      } catch (err) {
        this.$root.$emit('requestError', err);
      } finally {
        this.loading.submit = false;
      }
    },
  },
});
